<template>
  <liste-documents
    :categorie="categorie"
    :title="$t('menu.documents.resultatsAnalyses')"
  />
</template>

<script>
export default {
  props: {
    categorie: {
      type: String,
    },
  },
}
</script>
